


















































import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/calendar';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UiAutocompleteCity from '../UI/autocomplete-city.vue';
import UiAutocompleteUF from '../UI/autocomplete-uf.vue';
import UiDatePicker from '../UI/date-picker.vue';

@Component({
  components: { UiDatePicker, UiAutocompleteUF, UiAutocompleteCity }
})
export default class HolidayForm extends BaseComponent {
  @Prop()
  id: number;

  modalOpen = false;

  dto: any = {
    uf: null,
    tipo: 'N'
  };

  public form: any = {
    valid: false,
    rules: {
      data: [(v) => !!v || 'Informe a Data'],
      nome: [(v) => !!v || 'Informe o Nome'],
      uf: [(v) => !!v || 'Selecione o Estado'],
      municipio: [(v) => !!v || 'Selecione o Município']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (this.id == null) {
      setTimeout(() => {
        this.modalOpen = true;
      }, 50);
    }
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }

    this.loader.start('Carregando ...');
    service.getCalendarHoliday(id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.modalOpen = true;
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Processando ...');
    let obs: Observable<any> = null;
    if (this.dto.id) {
      obs = service.updateCalendarHoliday(this.dto);
    } else {
      obs = service.saveCalendarHoliday(this.dto);
    }

    obs.subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Feriado salvo com sucesso', 'success');
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }
}
